import {API_URL,Accept} from '../constants.js';
import {notify} from 'react-notify-toast';
import api from "./api.js";
export default function cancelHoldJob(trip_id,reason,url,status,component){
  const Authorization='bearer '+localStorage.getItem('token');
  const rider_id=localStorage.getItem('rider_id');
  fetch(`${API_URL}canceltrip`,{
    method:'POST',
    headers:{"Content-Type": "application/json",Accept,Authorization},
      body:JSON.stringify({rider_id,trip_id,reason})
        }).then(function(response){
          if(!response.ok){
              notify.show('Network Failure','error');
          }
            return response.json();
        })
        .then(function(data) {
            api.callAssignedJobs(component,'assigned');
    })
}



// WEBPACK FOOTER //
// ./src/utility/api/cancelHoldJob.js